import { endsWith } from 'lodash';

export const getPlanHomeUrl = () => {
  return process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : endsWith(window.location.host, 'socar.me')
      ? 'https://plan.socar.me'
      : 'https://plan.socar.kr';
};

export const getCookieDomain = () => {
  return process.env.NODE_ENV === 'development'
    ? 'localhost'
    : endsWith(window.location.host, 'socar.me')
      ? '.socar.me'
      : '.socar.kr';
};
